import React from "react";
import { useTranslation } from "react-i18next";
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import { formatDollarAmount } from "../../../../utils/methods";

interface TableHeaderSectionProps {
  total: number;
  kpis: any;
}

const TableHeaderSection: React.FC<TableHeaderSectionProps> = ({ total, kpis }) => {
  const { t } = useTranslation();
  
  return (
    <div className="col-md-12 header-section-div">
      <div className="row">
        <div className="col-sm-12 px-3 py-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <ReceiptOutlinedIcon className="menu-icon tf-icons ri-22px me-0" />
            <h5 className="mx-3 my-0">{t('invoices.addList.pageTexts.table.title')} ({total})</h5>
          </div>
          <div className="d-flex align-items-center">
            <span className="me-1 fw-semibold">{t("invoices.addList.pageTexts.table.kpis.totalAmountDue")}:</span>
            <span className="badge bg-secondary me-2">{kpis.totalAmountDue ? formatDollarAmount(kpis.totalAmountDue) : '-'}</span>

            <span className="mx-2">|</span>

            <span className="me-1 fw-semibold">{t("invoices.addList.pageTexts.table.kpis.totalInvoicesAmount")}:</span>
            <span className="badge bg-warning me-2">{kpis.totalInvoiceAmount ? formatDollarAmount(kpis.totalInvoiceAmount) : '-'}</span>

            <span className="mx-2">|</span>

            <span className="me-1 fw-semibold">{t("invoices.addList.pageTexts.table.kpis.totalCommission")}:</span>
            <span className="badge bg-success me-2">{kpis.totalCommission ? formatDollarAmount(kpis.totalCommission) : '-'}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TableHeaderSection;